import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Resolve,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CurrentUserAndPermissions } from './current-user-and-permissions';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class CurrentUserGuard
  implements Resolve<CurrentUserAndPermissions>, CanActivateChild
{
  constructor(private currentUserService: CurrentUserService) {}

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.currentUserService
      .getCurrentUser()
      .pipe(map(currentUser => Boolean(currentUser)));
  }

  resolve(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<CurrentUserAndPermissions> {
    return this.currentUserService.getCurrentUser();
  }
}
